import { LegacyCard, Form, FormLayout, Modal, LegacyStack, TextField } from '@shopify/polaris';
import { useContext, useState } from 'react';
import { putCustomer } from '../../../services/customersService';
import { SET_OK, SET_ERROR } from '../../../context/ToastReducer';
import ToastContext from '../../../context/ToastContext';

export const EditCustomerModal = (props) => {
  const { customer, active, id, onSave, onClose } = props;
  const [, dispatchToast] = useContext(ToastContext);

  const [dataForm, setDataForm] = useState(customer);

  const handleSubmit = () => {
    putCustomer(id, dataForm)
      .then((r) => {
        dispatchToast({ type: SET_OK, payload: r.data });
        onSave(dataForm);
        onClose();
      })
      .catch((e) => {
        dispatchToast({ type: SET_ERROR, payload: e.response.data });
      });
  };

  return (
    <Modal
      open={active}
      onClose={() => onClose()}
      title="Editar cliente"
      primaryAction={{
        content: 'Cambiar',
        onAction: handleSubmit,
      }}
    >
      <Modal.Section>
        {customer && (
          <Form>
            <FormLayout onSubmit={handleSubmit}>
              <LegacyCard.Section title="Identificación">
                <TextField
                  type="name"
                  label="Nombre"
                  placeholder={dataForm.name}
                  value={dataForm.name}
                  onChange={(e) => {
                    setDataForm({
                      ...dataForm,
                      name: e,
                    });
                  }}
                  autoComplete="off"
                />
                <TextField
                  type="name"
                  label="Email"
                  placeholder={dataForm.email}
                  value={dataForm.email}
                  onChange={(e) => {
                    setDataForm({
                      ...dataForm,
                      email: e,
                    });
                  }}
                  autoComplete="off"
                />
                <LegacyStack distribution="fillEvenly">
                  <TextField
                    type="name"
                    label="ID Fiscal RFC"
                    placeholder={dataForm.vat}
                    value={dataForm.vat}
                    onChange={(e) => {
                      setDataForm({
                        ...dataForm,
                        vat: e,
                      });
                    }}
                    autoComplete="off"
                  />

                  <TextField
                    type="name"
                    label="Teléfono"
                    placeholder={dataForm.phone}
                    value={dataForm.phone}
                    onChange={(e) => {
                      setDataForm({
                        ...dataForm,
                        phone: e,
                      });
                    }}
                    autoComplete="off"
                  />
                </LegacyStack>
              </LegacyCard.Section>
              <LegacyCard.Section title="Dirección">
                <LegacyStack distribution="fillEvenly">
                  <TextField
                    type="name"
                    label="Dirección"
                    placeholder={dataForm.address}
                    value={dataForm.address}
                    onChange={(e) => {
                      setDataForm({
                        ...dataForm,
                        address: e,
                      });
                    }}
                    autoComplete="off"
                  />

                  <TextField
                    type="name"
                    label="Zip"
                    placeholder={dataForm.zip}
                    value={dataForm.zip}
                    onChange={(e) => {
                      setDataForm({
                        ...dataForm,
                        zip: e,
                      });
                    }}
                    autoComplete="off"
                  />

                  <TextField
                    type="name"
                    label="Ciudad"
                    placeholder={dataForm.city}
                    value={dataForm.city}
                    onChange={(e) => {
                      setDataForm({
                        ...dataForm,
                        city: e,
                      });
                    }}
                    autoComplete="off"
                  />

                  <TextField
                    type="name"
                    label="Provincia"
                    placeholder={dataForm.state}
                    value={dataForm.state}
                    onChange={(e) => {
                      setDataForm({
                        ...dataForm,
                        state: e,
                      });
                    }}
                    autoComplete="off"
                  />

                  <TextField
                    type="name"
                    label="País"
                    placeholder={dataForm.country}
                    value={dataForm.country}
                    onChange={(e) => {
                      setDataForm({
                        ...dataForm,
                        country: e,
                      });
                    }}
                    autoComplete="off"
                  />
                </LegacyStack>
              </LegacyCard.Section>
            </FormLayout>
          </Form>
        )}
      </Modal.Section>
    </Modal>
  );
};
